module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnPgogICAgICAgIDxwYXRoIGZpbGw9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSJ3aGl0ZSIgZD0iTTE3IDJoM2ExIDEgMCAwIDEgMSAxdjE4YTEgMSAwIDAgMS0xIDFINGExIDEgMCAwIDEtMS0xVjNhMSAxIDAgMCAxIDEtMWgzVjBoMnYyaDZWMGgydjJ6bTAgMnYyaC0yVjRIOXYySDdWNEg1djE2aDE0VjRoLTJ6TTcgOGgxMHYySDdWOHptMCA0aDEwdjJIN3YtMnoiLz4KICAgIDwvZz4KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Menu/Todo-null.svg
// module id = 1910
// module chunks = 8